import type { RechercheDemandeQueryDTO, RechercheResultDTO } from '@/features/api/extranet/dto/Demande/Recherche'
import { buildRechercheStore } from '../shared'

export const useRechercheDemandeStore = buildRechercheStore<RechercheDemandeQueryDTO, RechercheResultDTO>({
  storeName: 'rechercheDemandeStore',
  apiPath: `/formation/demandes`,
  location: {
    to: 'recherche',
    domaine: 'formations',
    module: 'demande',
  }
})
